import { render, staticRenderFns } from "./nearNewsList.vue?vue&type=template&id=5f9ca656&scoped=true&"
import script from "./nearNewsList.vue?vue&type=script&lang=js&"
export * from "./nearNewsList.vue?vue&type=script&lang=js&"
import style0 from "./nearNewsList.vue?vue&type=style&index=0&id=5f9ca656&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9ca656",
  null
  
)

export default component.exports